module.exports = __webpack_public_path__ + "static/media/券商领取步骤@2x.e3799f5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_171/images/券商领取步骤@2x.png
// module id = 1550
// module chunks = 0